// extracted by mini-css-extract-plugin
module.exports = {"root":"author_root__njeAh","photo":"author_photo__GppFt","info":"author_info__IdwOw"};